<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <div v-if="disabled" class="m-1" style="font-size:1rem;">
      {{ valueDisplay }}
    </div>

    <div v-else
         class="d-flex fake-input p-0 align-items-center"
         :class="{ 'form-control': !disabled }"
    >
      <input
        :id="id"
        disabled
        type="text"
        :placeholder="placeholder"
        class="mr-1 form-control text-truncate"
        style="height: 30px;"
        :value="valueDisplay"
      />
      <AppButton
        @click="modals.modify = true"
      >
        <AppIcon name="add" />
      </AppButton>

    </div>
    <FormDepartmentOwnershipModal
      v-if="modals.modify === true"
      v-bind="{ config, inline, value: formattedValue }"
      @update="setValue"
      @close="modals.modify = false"
    />
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import FormDepartmentOwnershipModal from './Modals/FormDepartmentOwnershipModal'
import FormLabel from './FormLabel'
import { mapGetters } from 'vuex'

export default {
  mixins: [ FormMixin ],
  components: { FormDepartmentOwnershipModal, FormLabel },
  props: {
    config: {
      type: Object,
      default: () => ({ type: 'text' }),
    },
    inline: {
      type: Boolean,
      default: false,
    },
    formValue: {
      type: Object,
      default: () => ({ departments: [] }),
    },
  },
  data () {
    return { modals: { modify: false }, manuallyUpdated: true }
  },
  computed: {
    ...mapGetters('departments', [ 'departmentDisplayName' ]),
    valueDisplay () {
      return (this.formattedValue || []).map(dept => `${this.departmentDisplayName(dept.deptId)} - ${dept.percentOwnership || 'Not Set'}%`).join(', ')
    },
    isValidationEnabled () {
      return this.required || this.config?.validations?.sumOfPercentOwnership
    },
    mappedDepartments () {
      let departments = this.formValue.departments || []

      if (this.config.sourceQuestion) {
        departments = this.formValue[this.config.sourceQuestion.questionId] || []
      }
      return departments
    },
    formattedValue () {
      /*
      This computed property formats the value property by ensuring that
      a). if there is no value, a default is correctly generated from the parent's existing department array
      b). If there is a value, the value is merged correctly with the default because there may be items in the
      parent's department array that are not in the value array yet
      */

      const departments = this.mappedDepartments

      const defaultValue = departments.map(deptId => ({
        deptId,
        percentOwnership: null,
      }))

      /*
      If the value does not exist, return the default values with auto-generated percentages that are
      equally distributed only if validations are not enabled, otherwise this might cause confusion
      */
      if (!this.manuallyUpdated || !this.value || !this.value.length) {

        return defaultValue.map(defaultDept => {
          if (this.isValidationEnabled) return defaultDept

          return {
            ...defaultDept,
            percentOwnership: (100 / (departments.length || 1)).toFixed(2),
          }
        })
      }
      const existingValue = [ ...this.value ]

      const deptsFromDeptSelect = defaultValue.map(defaultDept => {
        const existingDept = existingValue.find(dept => dept.deptId === defaultDept.deptId)
        return existingDept || defaultDept
      })

      const deptsNotInDeptSelect = existingValue.filter(dept => dept.percentOwnership && !deptsFromDeptSelect.map(({ deptId }) => deptId).includes(dept.deptId))

      return [ ...deptsFromDeptSelect, ...deptsNotInDeptSelect ]
    },
  },
  watch: {
    mappedDepartments: {
      handler () {
        this.checkForExistingDepartments()
      },
    },
  },
  mounted () {
    if (!this.value || !this.value.length) {
      this.manuallyUpdated = false
    }

    this.checkForExistingDepartments()
  },
  methods: {
    setValue (value) {
      this.manuallyUpdated = true
      this.$emit('input', value)
    },
    checkForExistingDepartments () {
      const exisitngValue = this.value || []

      const existingDepartments = this.mappedDepartments.map((deptId) => deptId)

      const existingDeptValues = exisitngValue.filter(({ deptId }) => existingDepartments.includes(deptId))

      // When Dept has been added/removed to the mapped department question
      // then update the department ownership value
      if (existingDeptValues.length !== existingDepartments.length) { this.$emit('input', this.formattedValue) }
    },

  },
}
</script>
<style>
.fake-input {
  background-image: none !important;
}
</style>
